module.exports = __webpack_public_path__ + "img/NurEinBischenRegen.a885989e.svg";